import { Programmname, ProgrammteilnahmeEmailFieldBehaviour } from '@ps20/bff-models';
import { IAppState } from '../localStore';
import { PoliceVersandArtEnum } from '../model/policeVersandArt';
import { selectVersicherungsnehmerEmailIsNullOrEmpty } from './versicherungsnehmer.selector';
import { selectedProdukte } from './produkt.selector';

export const selectPoliceVersandArt = (state: IAppState): PoliceVersandArtEnum => {
  return state.policeVersand.versandArt;
};

export const selectPossibleVersandArten = (state: IAppState): Array<PoliceVersandArtEnum> => {
  if (state.versicherungsnehmer.email?.programmName === Programmname.DIGITALDOKUMENT) {
    return [PoliceVersandArtEnum.DIGITAL_VOLL_POLICE];
  }
  let versandArten = [
    PoliceVersandArtEnum.DIGITAL_VOLL_POLICE,
    PoliceVersandArtEnum.DIGITAL_TEIL_POLICE,
  ];
  const fieldBehaviour = state.versicherungsnehmer.email.fieldBehaviour;
  if (
    (fieldBehaviour === ProgrammteilnahmeEmailFieldBehaviour.OFFEN ||
      fieldBehaviour === ProgrammteilnahmeEmailFieldBehaviour.EDITIERBAR) &&
    selectVersicherungsnehmerEmailIsNullOrEmpty(state)
  ) {
    versandArten.push(PoliceVersandArtEnum.PAPIER_POLICE);
  }
  if (
    fieldBehaviour === ProgrammteilnahmeEmailFieldBehaviour.GESPERRT &&
    onlyErsatzgeschaeftProdukteExist(state)
  ) {
    versandArten = versandArten.filter(
      versandArten => versandArten != PoliceVersandArtEnum.DIGITAL_TEIL_POLICE,
    );
  }
  return versandArten;
};

const onlyErsatzgeschaeftProdukteExist = (state: IAppState): boolean => {
  const produkte = selectedProdukte(state);
  for (const produkt of produkte) {
    if (!produkt.vorvertragsnummer) {
      return false;
    }
  }
  return true;
};
